// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"2fa8bbd5","405":"5078b91f","453":"e8893d11","513":"ca75dd20","602":"69bcd714","633":"418cdef5","801":"fcd81d43","855":"0aeefa41"}[chunkId] + ".chunk.js";
};